import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import clsx from 'clsx';

export interface AccordionItem {
  id: string;
  question: string;
  answer: React.ReactNode;
}

export interface AccordionProps {
  items: AccordionItem[];
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({ items, className }) => {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set());

  const toggle = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div className={clsx('space-y-0', className)}>
      {items.map((item, index) => {
        const isOpen = openIds.has(item.id);
        return (
          <div
            key={item.id}
            className={clsx(
              'border-b border-border',
              index === 0 && 'border-t'
            )}
          >
            <button
              onClick={() => toggle(item.id)}
              className="w-full flex items-center justify-between py-4 text-left hover:text-primary transition-colors"
            >
              <span className="font-semibold text-text-primary pr-4">{item.question}</span>
              <ChevronDown
                className={clsx(
                  'h-5 w-5 text-text-muted transition-transform duration-200 flex-shrink-0',
                  isOpen && 'rotate-180'
                )}
              />
            </button>
            <div
              className={clsx(
                'overflow-hidden transition-all duration-200',
                isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
              )}
            >
              <div className="pb-4 text-text-secondary leading-relaxed">
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;